import { tryCatch, equals } from 'ramda'
import queryString from 'query-string'

const parseString = (_, state) => state
/**
 * @param {string} state
 */
const parseState = (state) => (typeof state === 'string' ? JSON.parse(state) : {})

/**
 * @param {string} key
 * @param {Storage} storage
 * @returns {Object}
 */
export const loadState = (key = 'user', storage = localStorage) =>
  tryCatch(parseState, parseString)(storage.getItem(key))

/**
 * @param state
 * @param {string} key
 * @param {Storage} storage
 */
export const saveState = (state, key = 'user', storage = localStorage) =>
  storage.setItem(key, JSON.stringify(state))

/**
 * @param {?string} refId
 */
export const saveRefId = (refId) => {
  const refIdFromStorage = loadState('refId', sessionStorage)

  return refId && !equals(refIdFromStorage, refId) && saveState(refId, 'refId', sessionStorage)
}

export const loadRefId = () => {
  const refIdFromStorage = loadState('refId', sessionStorage)
  const { refId } = queryString.parse(document.location.search)

  return refId || (typeof refIdFromStorage === 'string' ? refIdFromStorage : '')
}

/**
 * @param {?string} extRefId
 */
export const saveExtRefId = (extRefId) => {
  const extRefIdFromStorage = loadState('extRefId', sessionStorage)

  return extRefId && !equals(extRefIdFromStorage, extRefId) && saveState(extRefId, 'extRefId', sessionStorage)
}

export const loadExtRefId = () => {
  const extRefIdFromStorage = loadState('extRefId', sessionStorage)
  const { extRefId } = queryString.parse(document.location.search)

  return extRefId || (typeof extRefIdFromStorage === 'string' ? extRefIdFromStorage : '')
}
